import { PhoneNumber } from 'tria-ui-react-lib/constants/ContactInfo.json'

export const callHelp = () => {
  window.open(`tel:${PhoneNumber}`)
}
